import { writable } from 'svelte/store';

import { DEFAULT_NATIVE_VERSION } from 'src/constants';
import { isValidJSON } from 'src/helpers/validators';

export const app = writable(false);

export const os = writable('');

export const wearables_connected = writable(0);

export const android_version = writable(DEFAULT_NATIVE_VERSION);
export const ios_version = writable(DEFAULT_NATIVE_VERSION);

export const wifi_ssid = writable(
	isValidJSON(localStorage.getItem('wifi_ssid')) ? JSON.parse(localStorage.getItem('wifi_ssid')) : '',
);
wifi_ssid.subscribe((val) => localStorage.setItem('wifi_ssid', JSON.stringify(val)));

export const network = writable(
	isValidJSON(localStorage.getItem('network')) ? JSON.parse(localStorage.getItem('network')) : 'wifi',
);
network.subscribe((val) => localStorage.setItem('network', JSON.stringify(val)));

export const bluetooth = writable(
	isValidJSON(localStorage.getItem('bluetooth'))
		? JSON.parse(localStorage.getItem('bluetooth'))
		: 'unknown',
);
bluetooth.subscribe((val) => localStorage.setItem('bluetooth', JSON.stringify(val)));

export const location_state = writable(JSON.parse(localStorage.getItem('location_state')) || 'unknown');
location_state.subscribe((val) => localStorage.setItem('location_state', JSON.stringify(val)));

export const wifi_ssids = writable([]);

wifi_ssids.subscribe((ssids) => ssids);
